import { Building2 } from 'lucide-react';

export interface ReportHeaderProps {
  brand: string;
  monthRange?: string;
  date: Date;
}

// Lock timezone về Việt Nam — không phụ thuộc browser locale của user
const FORMATTER = new Intl.DateTimeFormat('vi-VN', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Asia/Ho_Chi_Minh',
});

export function ReportHeader({ brand, monthRange, date }: ReportHeaderProps) {
  return (
    <header className="flex items-end justify-between gap-6 border-b-2 border-primary pb-4 print-no-break">
      <div className="flex items-center gap-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Building2 className="h-7 w-7" strokeWidth={1.5} />
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            GearVN × {brand}
          </div>
          <h1 className="mt-1 text-2xl font-bold tracking-tight">
            Báo cáo Hiệu suất — {brand}
          </h1>
          <p className="mt-1 text-xs text-muted-foreground">
            Monitor Category{monthRange ? ` · ${monthRange}` : ''} · GearVN
          </p>
        </div>
      </div>

      <div className="text-right text-xs">
        <div className="text-foreground">Ngày xuất: {FORMATTER.format(date)}</div>
        <div className="mt-0.5 font-semibold uppercase tracking-wider text-destructive">
          Confidential — Internal use
        </div>
      </div>
    </header>
  );
}
